export const styleSheet = () => ({
  pageRoot: {
    marginTop: "20px",
    backgroundColor: "#F5F5F5",
    minHeight: "100vh",
  },
  sidebarDrawer: {
    width: "340px",
    padding: "0",
  },

  sidebarHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px",
    borderBottom: "1px solid #eee",
    backgroundColor: "#f8f8f8",
  },
  sidebarContent: {
    padding: "16px",
    overflowY: "auto",
  },
  positionSection: {
    marginTop: "24px",
    padding: "12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
  },
  sizeSection: {
    marginTop: "16px",
    padding: "12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
  },
  optionsSection: {
    marginTop: "24px",
    padding: "12px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
  },

  optionItem: {
    marginBottom: "8px",
  },
  actionButtons: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "32px",
    gap: "12px",
  },
  mPosition: {
    position: "relative",
    margin: "auto",
    width: "75%",
  },
  mCanvas: {
    display: "block",
    margin: "auto",
  },
  mColor: {
    backgroundColor: "#ededed",
  },
});
